import { getVariantPageUrl } from "../../../../../lib/common/js/helpers"
import * as pipeLoadingOverlay from "../../../../../lib/common/js/pipeLoadingOverlay"

export default (getView) =>
  ({
    nextStepPath,
    formFields,
    exitIntentPath,
    isExitIntent
  }) => ({
    ...getView({
      nextStepPath,
      formFields,
    }),

    init() {
      this.commonInit()

      if (isExitIntent) {

      } else {
        this.listenMouseOutExitIntent()

        this.store.values.marketingAgreed = false
        this.store.values.privacyAgreement = false
      }
    },

    listenMouseOutExitIntent() {
      window.addEventListener("mouseout", (e) => {
        if (e.clientY < 0) {

          window.location = getVariantPageUrl({ pagePath: exitIntentPath, pipelineConfig })
        }
      })
    },

    handleBackButtonExitIntent() {
      if (isExitIntent) {
        history.back()
      } else {
        window.location = getVariantPageUrl({ pagePath: exitIntentPath, pipelineConfig })
      }
    },

    getGoalWeightDiff() {
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values
  
      if (this.store.isMetric()) {
        return weightKg - targetWeightKg
      } else {
        return weightLbs - targetWeightLbs
      }
    },

    handleSubmit() {
      // Agreements are set here automatically as per products requirement.
      // On UI there is a text that user agrees by pressing 'next' button.
      this.store.values.marketingAgreed = true
      this.store.values.privacyAgreement = true
      const prevEmail = this.store.values.email
      const currentEmail = this.formValues.email

      this.submit({ push: true, isTrackingResetNeeded: currentEmail !== prevEmail })
    },
  })
